export const MOBILE = 580;
export const TABLET = 1024;
